//一些全局的config配置
const CONFIG = {
  // 正式环境
  'production': {
    // host: "http://116.63.225.178:1080",
    // host: "http://219.143.237.121:4281",
    host:"",
    code: "tqc",
    abbrCode: "ad-qq",
    appKey: "qVSdnaZOcOpe34SrOc9K0ar0TNt4qEDgek",
    appSecret:"4oQzTPSgbxYuhUHLO80dD4Hir7HQ30sMOLT1un8TVCQqXQB8p61PflidvWc0Y8Gxu4TcMzZ0dcHTKdTBk1lbGZfxhntdaMxU8uKciYMBLaZkqWR4lSy6arZ4w0910x",
    appSeed: "fxmY9eFATqXBZHwQTp9GNlP46IpsYXfhJeDHyvBxUsftNH0RQn"
  },
  //测试环境
  'test': {
    // host: "http://219.143.237.121:4281",
    // host:"",
    host:"",
    code: "tqc",
    abbrCode: "ad-qq",
    appKey: "qVSdnaZOcOpe34SrOc9K0ar0TNt4qEDgek",
    appSecret:"4oQzTPSgbxYuhUHLO80dD4Hir7HQ30sMOLT1un8TVCQqXQB8p61PflidvWc0Y8Gxu4TcMzZ0dcHTKdTBk1lbGZfxhntdaMxU8uKciYMBLaZkqWR4lSy6arZ4w0910x",
    appSeed: "fxmY9eFATqXBZHwQTp9GNlP46IpsYXfhJeDHyvBxUsftNH0RQn"
  },
  //本地环境
  'development': {
    // host: "http://219.143.237.121:4281",
    // host:"",
    host:"",
    code: "tqc",
    abbrCode: "ad-qq",
    appKey: "qVSdnaZOcOpe34SrOc9K0ar0TNt4qEDgek",
    appSecret:"4oQzTPSgbxYuhUHLO80dD4Hir7HQ30sMOLT1un8TVCQqXQB8p61PflidvWc0Y8Gxu4TcMzZ0dcHTKdTBk1lbGZfxhntdaMxU8uKciYMBLaZkqWR4lSy6arZ4w0910x",
    appSeed: "fxmY9eFATqXBZHwQTp9GNlP46IpsYXfhJeDHyvBxUsftNH0RQn"
  },
};
export default CONFIG[process.env.NODE_ENV];



// WEBPACK FOOTER //
// ./src/index.js